import React from 'react'
import { setQuestions, setStep } from '../../../../redux/reducers/models'
import { useSelector, useDispatch } from 'react-redux'
import '../../../../styles/components/RenderAR.scss'
import ButtonStart from '../../../ButtonStart/'

const NextSection = () => {
  const { questions, step, arStarted, speakerOption } = useSelector(
    (state) => state.models
  )
  const dispatch = useDispatch()

  const handleBackBtn = () => {
    if (speakerOption === 1) {
      dispatch(setQuestions(1))
      dispatch(setStep(1))
    } else {
      dispatch(setQuestions(questions - 1))
      dispatch(setStep(step - 1))
    }
  }

  return (
    <div className='instructions'>
      <p className='instructions__subtitle'>
        Click on the cube button to enter in AR mode. Once in AR mode, you can
        stick the model to the floor by following the instructions.
      </p>
      <br />
      <p className='instructions__subtitle'>
        When you are done, you may leave the AR mode and click on the Next
        button to continue.
      </p>
      <div className='instructions__btns'>
        <button
          onClick={handleBackBtn}
          type='button'
          className='instructions__btns__btn'
        >
          Go Back
        </button>
        {arStarted && (
          <ButtonStart onClick={() => dispatch(setQuestions(questions + 1))}>
            NEXT
          </ButtonStart>
        )}
      </div>
    </div>
  )
}

export default NextSection
